module.exports = __webpack_public_path__ + "static/pic05-d82e61241e70622b517cab61e99a61ee.jpg";